import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'dealersQuota': [],
  'totalQuota': 0,
};

export const dailyQuota = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_GET_PRIORIZATION_DAILY_QUOTA]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_GET_PRIORIZATION_DAILY_QUOTA]: (state, action) => ({
      ...state,
      'loading': false,
      'dealersQuota': action.response.data.dealerQuota,
      'totalQuota': action.response.data.dailyQuota,
    }),
    [ActionTypes.FETCH_GET_PRIORIZATION_DAILY_QUOTA_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),

    [ActionTypes.FETCHING_UPDATE_PRIORIZATION_DAILY_QUOTA]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_UPDATE_PRIORIZATION_DAILY_QUOTA]: (state, action) => ({
      ...state,
      'loading': false,
      'dealersQuota': action.response.data.dealerQuota,
      'totalQuota': action.response.data.dailyQuota,
    }),
    [ActionTypes.FETCH_UPDATE_PRIORIZATION_DAILY_QUOTA_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'floatingInventoryData': [],
    }),

  })(state, action);
};
